module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box american-credit-partner"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("American Credit® Vendor Financing Program")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/partner'
      }
    }
  }, [_vm._v("Get Started")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), [_c('RowSection', {
    attrs: {
      "img-side": "right",
      "imageName": "American-Credit-Vendor-Financing-Think-Different.png",
      "altText": "American Credit Vendor Financing Think Different"
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('h2', [_vm._v("Successful companies think different")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
          staticStyle: {
            "font-weight": "900"
          }
        }, [_vm._v("Increase sales and profits.")]), _c('br'), _vm._v("An in-house financing partnership customized for your business and the needs of your clients.")]), _vm._v(" "), _c('li', [_c('span', {
          staticStyle: {
            "font-weight": "900"
          }
        }, [_vm._v("Partnership Power")]), _c('br'), _vm._v("Partnering with us, gives you the financing options your customers demand without the associated challenges and hassles.")]), _vm._v(" "), _c('li', [_c('span', {
          staticStyle: {
            "font-weight": "900"
          }
        }, [_vm._v("Better client relationships and retention.")]), _c('br'), _vm._v("We help you sell more, smarter, and faster with our technology and transparency.")])])]
      },
      proxy: true
    }])
  })], _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white",
      "padding-top": "90px"
    },
    attrs: {
      "id": "drop-line"
    }
  }, [_c('div', {
    staticClass: "container platform contact-us"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 contact-us-left"
  }, [_c('h4', {
    staticClass: "contact-us-title"
  }, [_vm._v("Drop us a line")]), _vm._v(" "), _c('p', {
    staticClass: "contact-us-text"
  }, [_vm._v("Whether you want to start a partnership or become a broker, we are happy to work with you. Please feel free to send us a message.")]), _vm._v(" "), _c('el-form', {
    ref: "step2Form",
    staticClass: "row",
    attrs: {
      "label-width": '0',
      "model": _vm.step2Form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "col-6",
    attrs: {
      "prop": "firstName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "First Name*"
    },
    model: {
      value: (_vm.step2Form.firstName),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "firstName", $$v)
      },
      expression: "step2Form.firstName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6",
    attrs: {
      "prop": "lastName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Last Name*"
    },
    model: {
      value: (_vm.step2Form.lastName),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "lastName", $$v)
      },
      expression: "step2Form.lastName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6",
    attrs: {
      "prop": "email",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Email*"
    },
    model: {
      value: (_vm.step2Form.email),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "email", $$v)
      },
      expression: "step2Form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6",
    attrs: {
      "prop": "phone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "Phone*"
    },
    model: {
      value: (_vm.step2Form.phone),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "phone", $$v)
      },
      expression: "step2Form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-12",
    attrs: {
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Message content."
    },
    model: {
      value: (_vm.step2Form.content),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "content", $$v)
      },
      expression: "step2Form.content"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-button', {
    staticClass: "rounded-pill font-weight-bold",
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "54px",
      "width": "190px",
      "border-radius": "27px",
      "border": "none",
      "margin-top": "36px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Send Message")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform trust-us"
  }, [_c('div', {
    staticClass: "row trust-us-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 trust-us-inner-left"
  }, [_c('div', [_c('p', {
    staticClass: "trust-us-title"
  }, [_vm._v("American Credit: The difference you can trust")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "trust-us-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = '/partner'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _vm._m(11)])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Leveraging American Credit’s fully-digital fintech lending platform. Help your client access fast, simple, and flexible equipment financing. Sell more, sell faster, and sell smarter. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/partner"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "american-credit-partner-main-img",
    attrs: {
      "src": require("../assets/imgs/American-Credit-Vendor-Financing.jpg"),
      "alt": "American Credit Vendor Financing"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h2', {
    staticClass: "text-center",
    staticStyle: {
      "font-family": "Biotif",
      "color": "#252525",
      "font-size": "36px",
      "font-weight": "600",
      "margin-bottom": "60px"
    }
  }, [_vm._v("Power and Advantage")]), _vm._v(" "), _c('div', {
    staticClass: "row user-feedback partner-with-leaders"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Vendor-Financing-Fully-Digital.png"),
      "alt": "American Credit Vendor Financing Fully Digital"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('h2', {
    staticClass: "partner-with-leaders-title"
  }, [_vm._v("The Bank in your pocket!")]), _vm._v(" "), _c('p', {
    staticClass: "partner-with-leaders-text"
  }, [_vm._v("Experience the power & competitive advantage of fully digital in-house financing.\n              "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n              • Paperless\n              "), _c('br'), _vm._v("\n              • Fully-digital\n              "), _c('br'), _vm._v("\n              • Flexible payment options\n              "), _c('br'), _vm._v("\n              • Fast credit decisions\n              "), _c('br'), _vm._v("\n              • Financing A - C credit\n            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#eff9ff"
    }
  }, [_c('div', {
    staticClass: "container new_bluebg benefits"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("\n          Benefits to vendors\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row text-center benefit-items"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item offset-lg-1"
  }, [_c('div', {
    staticClass: "benefit-item-inner benefit-item-vendor"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Vendor-Benefits-Icon-1.png"),
      "alt": "American Credit Vendor Benefits Icon 1"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Offer your customers the convenience of one-stop-shopping with American Credit’s all-inclusive 100% equipment financing (A to C Credit).")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner benefit-item-vendor"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Vendor-Benefits-Icon-2.png"),
      "alt": "American Credit Vendor Benefits Icon 2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Get paid up front & sell at full price. No more discounting to cut into your margins. Terms to 72 months with rates starting at 6%.")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner benefit-item-vendor"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Vendor-Benefits-Icon-3.png"),
      "alt": "American Credit Vendor Benefits Icon 3"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Hassle-free application only, approvals to $350,000."), _c('br'), _vm._v("Fully digital same-day approval & electronic 2-day funding's.")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner benefit-item-vendor"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Vendor-Benefits-Icon-4.png"),
      "alt": "American Credit Vendor Benefits Icon 4"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("We finance all costs associated with equipment purchase (delivery to maintenance, etc.).")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner benefit-item-vendor"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Vendor-Benefits-Icon-5.png"),
      "alt": "American Credit Vendor Benefits Icon 5"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Customized sales and marketing support & free training for your staff.")]), _vm._v(" "), _c('br')])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform referral-program"
  }, [_c('div', {
    staticClass: "row referral-program-inner"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 referral-program-inner-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Vendor-Financing-Customized-Marketing.png"),
      "alt": "American Credit Vendor Financing Customized Marketing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 referral-program-inner-right"
  }, [_c('h2', [_vm._v("Customized Marketing Programs")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("TAILORED MARKETING PROGRAMS")]), _c('br'), _vm._v("We create tailored landing pages on the American Credit website that offer financing promotions to your prospects based on their unique needs.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Email Marketing")]), _c('br'), _vm._v("American Credit will help you with email marketing and messaging that will get a better response from your prospects."), _c('br'), _vm._v("We may be able to expand your reach with email marketing ideas and concepts that will engage prospects.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Co-branded Landing Pages")]), _c('br'), _vm._v("We create tailored landing pages on our website that offer financing promotions to your prospects based on their unique needs.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Advertising Flyers / Datasheets")]), _c('br'), _vm._v("We design co-branded flyers or datasheets in PDF format for your use in turning prospects into sales")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container benefits",
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("\n          SELL FASTER & SELL SMARTER\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('div', {
    staticClass: "row text-center flow-charm-container"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1 flow-charm"
  }, [_c('div', {
    staticClass: "row flow-charm-vendor-financing"
  }, [_c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('div', {
    staticClass: "flow-charm-item-number"
  }, [_c('h3', [_vm._v("1")])]), _vm._v(" "), _c('p', [_vm._v("Your client completes our online application")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('div', {
    staticClass: "flow-charm-item-number"
  }, [_c('h3', [_vm._v("2")])]), _vm._v(" "), _c('p', [_vm._v("Qualified client receives approval with multiple options")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('div', {
    staticClass: "flow-charm-item-number"
  }, [_c('h3', [_vm._v("3")])]), _vm._v(" "), _c('p', [_vm._v("Client chooses the payment they want")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('div', {
    staticClass: "flow-charm-item-number"
  }, [_c('h3', [_vm._v("4")])]), _vm._v(" "), _c('p', [_vm._v("Client signs electronic contract with us, provides proof of ownership, company status, and photo ID")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('div', {
    staticClass: "flow-charm-item-number"
  }, [_c('h3', [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("You, the vendor, receive the payment, client takes delivery")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "offset-lg-1"
  }, [_vm._v("Next Steps")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center benefit-items"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item offset-lg-1 dot-container new_bluebg"
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot-inner text-left"
  }, [_c('h3', [_vm._v("Understanding your business and clients")]), _vm._v(" "), _c('p', [_vm._v("Every client is different with a unique set of needs. First step is to get a holistic understanding of you, your business, and your clients.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item dot-container new_bluebg"
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot-inner text-left"
  }, [_c('h3', [_vm._v("Zoom call or in"), _c('br'), _vm._v("person meeting")]), _vm._v(" "), _c('p', [_vm._v("After you complete our new partner questionaire, we meet internally with our vendor team to put together a custom proposal tailored to your business and clients.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item dot-container new_bluebg"
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot-inner text-left"
  }, [_c('h3', [_vm._v("Vendor Approval")]), _vm._v(" "), _c('p', [_vm._v("After we get your company cleared as an approved vendor, we can begin the build out.")]), _vm._v(" "), _c('p', [_vm._v("We can add you to our website and vice versa, so clients have a way to begin the online application.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item dot-container new_bluebg"
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot-inner text-left"
  }, [_c('h3', [_vm._v("Training &"), _c('br'), _vm._v("Marketing")]), _vm._v(" "), _c('p', [_vm._v("We will conduct a training session for your staff and sales team to ensure we are on the same page. As important we add an additional session where we answer any and all questions your company have.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-2 pt-2 benefit-item dot-container new_bluebg"
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot-inner text-left"
  }, [_c('h3', [_vm._v("Submissions and"), _c('br'), _vm._v("Funding")]), _vm._v(" "), _c('p', [_vm._v("Now we are at the fun part where we can start delivering the bottom line impact of helping you increase sales, profits, and take your business to the ext level.")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container benefits",
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('h2', [_vm._v("TOOLS TO HELP YOU GENERATE SALES")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center benefit-items"
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 benefit-item"
  }, [_c('div', {
    staticClass: "tools-help-sale text-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Financing-Widget.png"),
      "alt": "American Credit Financing Widget"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Financing Widget")]), _vm._v(" "), _c('p', [_vm._v("Put our Financing Widget on your website that allows your customers and website visitors to learn about their financing options and to easily apply for financing from your website.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 benefit-item"
  }, [_c('div', {
    staticClass: "tools-help-sale text-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Payment-Calculator-Widget.png"),
      "alt": "American Credit Payment Calculator Widget"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Payment Calculator"), _c('br'), _vm._v("Widget")]), _vm._v(" "), _c('p', [_vm._v("Easily install our payment calculator widget on your website. It gives your prospects and website visitors the opportunity to get estimated payments for financing.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 benefit-item"
  }, [_c('div', {
    staticClass: "tools-help-sale text-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American-Credit-Apple-Mobile-Payment-Calculator.png"),
      "alt": "American Credit Apple Mobile Payment Calculator"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Apple Mobile Payment Calculator")]), _vm._v(" "), _c('p', [_vm._v("Send prospects to our mobile app to get estimated monthly financing payments.")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container benefits",
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "tips-to-sell-banner"
  }, [_c('h2', [_vm._v("TIPS ON HOW TO SELL"), _c('br'), _vm._v("FINANCING")])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center benefit-items"
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 benefit-item"
  }, [_c('div', {
    staticClass: "tips-to-sell-item text-left"
  }, [_c('div', {
    staticClass: "tips-to-sell-item-number"
  }, [_vm._v("01")]), _vm._v(" "), _c('h3', [_vm._v("Include a monthly"), _c('br'), _vm._v("payment on every"), _c('br'), _vm._v("equipment quote")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 benefit-item"
  }, [_c('div', {
    staticClass: "tips-to-sell-item text-left"
  }, [_c('div', {
    staticClass: "tips-to-sell-item-number"
  }, [_vm._v("02")]), _vm._v(" "), _c('h3', [_vm._v("Sell the monthly"), _c('br'), _vm._v("payment, not the"), _c('br'), _vm._v("equipment price")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 benefit-item"
  }, [_c('div', {
    staticClass: "tips-to-sell-item text-left"
  }, [_c('div', {
    staticClass: "tips-to-sell-item-number"
  }, [_vm._v("03")]), _vm._v(" "), _c('h3', [_vm._v("It’s easier to justify"), _c('br'), _vm._v("productivity gains or"), _c('br'), _vm._v("cost savings with a"), _c('br'), _vm._v("monthly payment")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 contact-us-right"
  }, [_c('h4', {
    staticClass: "contact-us-title"
  }, [_vm._v("Get in touch with us")]), _vm._v(" "), _c('p', {
    staticClass: "contact-us-text"
  }, [_vm._v("We understand. Sometimes you just want to get a few answers and move on with business.")]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_location.png"),
      "alt": "american credit location"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Address")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("2100 Geng Road, Suite 210"), _c('br'), _vm._v(" Palo Alto, CA 94303")])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_phone.png"),
      "alt": "american credit phone"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Phone")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:1855-904-0188"
    }
  }, [_vm._v("855-904-0188")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_email.png"),
      "alt": "american credit email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Email")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:info@amcredit.com"
    }
  }, [_vm._v("info@amcredit.com")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trust-us-text",
    staticStyle: {
      "color": "#686868",
      "font-weight": "300"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("You work hard. We work hard. We share the same ethic.")]), _vm._v(" That’s why we go the extra mile to look at your situation and see if we can help. Unlike some business credit lenders who focus on FICO scores, we look at your business as a whole.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "contact-us"
    }
  }, [_vm._v("Feel free to contact us "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 trust-us-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_loans_the_Difference_You_can_Trust.png"),
      "alt": "American Credit Business loans the Difference You can Trust"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e602fdd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/VendorFinancing.vue
// module id = 1971
// module chunks = 5